// Pull the outward code (the bit before the space) out of a UK postcode: "SW1A 1AA" -> "SW1A".
// Falls back to stripping the inward code when the postcode was entered without a space.
//
// The outward code is deliberately coarse — it identifies a district rather than a street,
// which is what the operations crew list and the crew app both want.
export const getPostcodeOutwardCode = (postcode?: string | null) => {
  const trimmed = postcode?.trim().toUpperCase()
  if (!trimmed) return null
  const outward = trimmed.includes(' ') ? trimmed.split(/\s+/)[0] : trimmed.replace(/\d[A-Z]{2}$/, '')
  return outward || null
}
